import { Box, Card, Divider, Grid, Typography } from "@mui/material"
import GoBackButton from "../../components/go-back-button"
import CreateEditTransactionForm from "./create-edit.form"
import { useParams } from "react-router-dom"

export default function CreateEditTransaction() {
    const params = useParams();
    const editMode = params.transactionid != null ? true : false;

    return(
        <>
            <Box mt={3} mb={1}>
                <Box mb={1.5}>
                    <GoBackButton />
                </Box>
                <Grid container alignItems="center" spacing={1}>
                    <Grid>
                        <Typography variant="h4" fontWeight={700} sx={{ color: 'primary.main', letterSpacing: 1 }}>
                            {editMode === false ? "Nova Transação" : "Editar Transação"}
                        </Typography>
                    </Grid>
                </Grid>
                <Divider sx={{ mt: 2, borderColor: 'rgba(255,215,0,0.15)' }} />
                <Box mt={2}>
                    <Card sx={{ border: '1px solid rgba(255,215,0,0.15)' }}>
                        <CreateEditTransactionForm editMode={editMode} transactionId={params.transactionid} />
                    </Card>
                </Box>
            </Box>
        </>
    )
}